#import "../fragments/lead-attachments-fragment.graphql"

mutation AddAttachmentToLead($input: LeadFileAddInput!) {
    leadFilesAdd(input: $input) {
        lead {
            ...LeadAttachmentsFragment
        }
    }
}
